require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/old_vendors/moment/moment.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/old_vendors/moment/moment.legacy.js
// module id = 569
// module chunks = 31